import * as React from "react";
import {Fragment} from "react";
import {withRouter} from "react-router-dom";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import TransactionRequest from "../../../domain/Transaction/TransactionRequest";
import TransactionService from "../../../services/Transaction/TransactionService";
import TransactionRequiredFieldsComponent from "../../../components/TransactionRequiredFieldsComponent";
import QuotationComponent from "../../../components/QuotationComponent";
import "../../Authenticated/Transactions/transactionCreation.css"
import SFXLoadingComponent from "../../../components/SFXLoadingComponent";
import QuotationResponseComponent from "../../../components/QuotationResponseComponent";
import {Card, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import TransactionCompleteCard from "../../../components/TransactionCompleteCard";
import OutboundDeclarationComponent from "../../../components/OutboundDeclarationComponent";

const QUOTATION_REQUEST = "quotation request";
const QUOTATION_RESPONSE = "quotation response";
const BENEFICIARY_DETAILS = "beneficiary details";
const TRANSACTION_DETAILS = "transaction details";

class TransactionCreation extends React.Component {

    constructor(props) {
        super(props);

        this.registrationId = this.props.customer.registrationId;
        this.quotationRef = null;
        this.requiredFieldsRef = null;

        this.state = {
            currentTab: QUOTATION_REQUEST,

            quotationResponse: null,
            transactionRequest: null,
            transactionResponse: null,

            loading: false,
            requiredFieldsValid: false,

            showTransactionCompleteModal: false,
            showErrorModal: false,
            quotationErrors: []
        };

        this.retrieveQuotationResponse = this.retrieveQuotationResponse.bind(this);
        this.requiredFieldsValid = this.requiredFieldsValid.bind(this);
    }

    componentDidMount() {
        this.props.setSelectedScreen("Transactions");
    }

    retrieveQuotationResponse = (quotationRequest, quotationResponse) => {

        this.setState({
            quotationResponse: quotationResponse,
            currentTab: QUOTATION_RESPONSE
        })
    };

    requiredFieldsValid = isValid => {
        this.setState({
            requiredFieldsValid: isValid
        })
    };

    generateTransactionRequest() {

        let beneficiaryDetails = this.requiredFieldsRef.getValues();

        let transactionRequest = TransactionRequest.create(
            this.state.quotationResponse.quotationReference,
            this.props.customer.registrationId,
            beneficiaryDetails["captured-fields"],
            beneficiaryDetails["save-beneficiary"]
        );

        this.setState({
            transactionRequest: transactionRequest,
            loading: true
        }, () => this.createTransaction(transactionRequest))
    }

    createTransaction(transactionRequest) {

        TransactionService.createTransaction(transactionRequest).then(response => {
            if (response["error-code"]) {
                this.setState({
                    loading: false,
                    showErrorModal: true,
                    quotationErrors: response
                })
            } else {
                this.setState({
                    transactionResponse: response,
                    currentTab: TRANSACTION_DETAILS,
                    loading: false
                })
            }
        })
    }

    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>

            {this.props.isMobile ? this.renderContent("mobile") : this.renderContent("browser")}

        </Fragment>
    }

    renderContent(className) {

        return <Fragment>

            {this.renderQuotationExpiredModal(className)}

            {this.state.currentTab === QUOTATION_REQUEST && this.renderQuotationRequest(className)}
            {this.state.currentTab === QUOTATION_RESPONSE && (className === 'mobile' ? this.renderQuotationResponse(className) : this.renderBrowserQuotationResponse(className))}
            {this.state.currentTab === BENEFICIARY_DETAILS && (className === 'mobile' ? this.renderBeneficiaryDetails(className) : this.renderBrowserBeneficiaryDetails(className))}
            {this.state.currentTab === TRANSACTION_DETAILS && this.renderTransactionDetails(className)}

        </Fragment>

    }

    renderQuotationRequest(className) {

        return <Fragment>

            <QuotationComponent
                registrationId={this.registrationId}
                quotationRef={ref => this.quotationRef = ref}
                className={className}
                returnQuotationResponse={this.retrieveQuotationResponse}
                setHeader={() => this.props.setHeader("New Transaction")}
            />

        </Fragment>

    }

    renderQuotationResponse(className) {

        return <Fragment>

            <QuotationResponseComponent
                className={className}
                quotationResponse={this.state.quotationResponse}
                setHeader={() => this.props.setHeader("Your Quote")}
            />
            {this.renderDeclaration(className)}
            {this.renderAcceptQuoteButton(className)}
            {this.renderNewQuoteButton(className)}

        </Fragment>
    }

    renderBrowserQuotationResponse(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderQuotationResponse(className)}
        </Card>
    }

    renderBeneficiaryDetails(className) {

        return <Fragment>

            <TransactionRequiredFieldsComponent
                registerRef={ref => {
                    this.requiredFieldsRef = ref
                }}
                className={className}
                requiredFields={this.state.quotationResponse.requiredFields}
                isValid={this.requiredFieldsValid}
                setHeader={() => this.props.setHeader("Beneficiary Details")}
            />

            {this.renderCompleteTransactionButton(className)}

        </Fragment>
    }

    renderBrowserBeneficiaryDetails(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderBeneficiaryDetails(className)}
        </Card>
    }

    renderTransactionDetails(className) {

        return <Fragment>

            <TransactionCompleteCard
                className={className}
                transaction={this.state.transactionResponse}
            />

        </Fragment>

    }

    renderDeclaration(className){
        return  <OutboundDeclarationComponent
            className={className}
            quoteBopCategory={this.state.quotationResponse.bopCategory}
        />
    }

    renderAcceptQuoteButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_orange_oval_button"}
                onClick={() => this.setState({currentTab: BENEFICIARY_DETAILS})}
            >Accept
            </SFXButtonComponent>
        </div>
    }

    renderNewQuoteButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_grey_oval_button"}
                onClick={() => this.setState({currentTab: QUOTATION_REQUEST})}
            >New Quote
            </SFXButtonComponent>
        </div>
    }

    renderCompleteTransactionButton(className) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_orange_oval_button"}
                onClick={() => this.generateTransactionRequest()}
                disabled={!this.state.requiredFieldsValid}
            >Complete
            </SFXButtonComponent>
        </div>

    }

    renderQuotationExpiredModal(className) {

        return <Modal isOpen={this.state.showErrorModal} style={{borderRadius: " 25px"}}>

            <ModalHeader className={className + "_modal_header"}>{this.state.quotationErrors["message"]}</ModalHeader>
            <ModalBody>{this.state.quotationErrors["errors"]}</ModalBody>
            <ModalFooter>
                <SFXButtonComponent
                    onClick={() => this.setState({
                        showErrorModal: false,
                        currentTab: QUOTATION_REQUEST
                    })}
                >
                    Close
                </SFXButtonComponent>
            </ModalFooter>

        </Modal>

    }
}

export default withRouter(TransactionCreation);
